import * as React from 'react';
import cn from 'classnames';

import { LoadingStage } from 'shared/entities/meta';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';
import LoaderSpinner from 'shared/newComponents/animations/LoaderSpinner';
import {
  LoaderSpinnerSize,
  LoaderSpinnerColor
} from 'shared/newEntities/components/LoaderSpinner';

import styles from './IconButton.modules.scss';

export type ButtonIconProps = {
  Icon: React.FC<CommonIconProps>;
  href?: string;
  rel?: string;
  onClick: () => void;
  loadingStage?: LoadingStage;
  className?: string;
  disabled?: boolean;
};

const IconButton: React.FC<ButtonIconProps> = ({
  Icon,
  onClick,
  className,
  loadingStage,
  href,
  rel,
  disabled = false
}) => {
  const isLoading = loadingStage === LoadingStage.LOADING;

  const handleClick = React.useCallback(() => {
    if (disabled) {
      return;
    }
    onClick();
  }, [disabled, onClick]);

  return (
    <a
      href={disabled ? undefined : href}
      rel={rel}
      styleName="button"
      type="button"
      className={cn(className, disabled && styles.button_disabled)}
      onClick={handleClick}
    >
      {!isLoading && <Icon iconSize={IconSize.XL} />}
      {isLoading && (
        <div styleName="button__loader">
          <LoaderSpinner
            size={LoaderSpinnerSize.sm}
            color={LoaderSpinnerColor.blue}
          />
        </div>
      )}
    </a>
  );
};
export default React.memo(IconButton);
